import logo from './assets/Estralabs_logo.png';
import './App.css';
import BasicButtons from './components/button';
import WhoWeAre from './components/WhoWeAre';
import Products from "./components/Products"; 
import Imagen from './components/Imagen';
import Filosofia from "./components/Filosofia";
import Questions from "./components/Questions";
import Contacto from './components/Contacto';
import { Link } from "react-scroll";



function App() {
  return (
    <div className="App">
      <header className="App-header">
        
        <img src={logo} className="small-logo" alt="small logo" />
        
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          De la <b>estrategia </b> <span className="gray-text">a la acción</span>: <br></br> creamos software que impulsa
          <br></br> negocios y transforma <br></br> industrias.
        </p> 

<Link to="productos" smooth={true} duration={500}>
  <BasicButtons text="Nuestros productos" />
</Link>

      </header>
      <WhoWeAre/>
      <Products/>
      <Imagen/>
      <Filosofia/>
      <Questions/>
      <Contacto/>
    </div>
  );
}


export default App;







